// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"113":"91534d49","138":"c78f9537","394":"ce0ae179","416":"688b5c7b","517":"33e7f53e","522":"a6ff237d","573":"5ff8c97f","761":"93fe7505","898":"87e3534b"}[chunkId] + ".js";
};